/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_1_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to Toolverse. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services. We are committed to protecting your personal information and your right to privacy.`)
};

const es_privacy_section_1_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenido a Toolverse. Esta Política de Privacidad explica cómo recopilamos, usamos, divulgamos y protegemos tu información cuando visitas nuestro sitio web y usas nuestros servicios. Estamos comprometidos con la protección de tu información personal y tu derecho a la privacidad.`)
};

const de_privacy_section_1_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen bei Toolverse. Diese Datenschutzrichtlinie erläutert, wie wir Ihre Informationen erfassen, verwenden, offenlegen und schützen, wenn Sie unsere Website besuchen und unsere Dienste nutzen. Wir sind dem Schutz Ihrer persönlichen Daten und Ihres Rechts auf Privatsphäre verpflichtet.`)
};

const nl_privacy_section_1_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welkom bij Toolverse. Dit privacybeleid legt uit hoe we uw informatie verzamelen, gebruiken, openbaar maken en beschermen wanneer u onze website bezoekt en onze diensten gebruikt. We zijn toegewijd aan het beschermen van uw persoonlijke informatie en uw recht op privacy.`)
};

const fr_privacy_section_1_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue sur Toolverse. Cette politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous visitez notre site web et utilisez nos services. Nous nous engageons à protéger vos informations personnelles et votre droit à la vie privée.`)
};

const it_privacy_section_1_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benvenuto su Toolverse. Questa Informativa sulla Privacy spiega come raccogliamo, utilizziamo, divulghiamo e proteggiamo le tue informazioni quando visiti il nostro sito web e utilizzi i nostri servizi. Ci impegniamo a proteggere le tue informazioni personali e il tuo diritto alla privacy.`)
};

const pt_br2_privacy_section_1_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-vindo à Toolverse. Esta Política de Privacidade explica como coletamos, usamos, divulgamos e protegemos suas informações quando você visita nosso site e utiliza nossos serviços. Estamos comprometidos em proteger suas informações pessoais e seu direito à privacidade.`)
};

const pt_privacy_section_1_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-vindo à Toolverse. Esta Política de Privacidade explica como recolhemos, utilizamos, divulgamos e protegemos as suas informações quando visita o nosso website e utiliza os nossos serviços. Estamos empenhados em proteger as suas informações pessoais e o seu direito à privacidade.`)
};

const ja_privacy_section_1_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverseへようこそ。このプライバシーポリシーは、当ウェブサイトを訪問しサービスを利用する際に、どのように情報を収集、使用、開示、保護するかについて説明します。私たちはお客様の個人情報とプライバシーの権利の保護に取り組んでいます。`)
};

const zh_privacy_section_1_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎来到Toolverse。本隐私政策说明了当您访问我们的网站和使用我们的服务时，我们如何收集、使用、披露和保护您的信息。我们致力于保护您的个人信息和隐私权。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_1_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_1_text(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_1_text", locale)
	if (locale === "en") return en_privacy_section_1_text(inputs)
	if (locale === "es") return es_privacy_section_1_text(inputs)
	if (locale === "de") return de_privacy_section_1_text(inputs)
	if (locale === "nl") return nl_privacy_section_1_text(inputs)
	if (locale === "fr") return fr_privacy_section_1_text(inputs)
	if (locale === "it") return it_privacy_section_1_text(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_1_text(inputs)
	if (locale === "pt") return pt_privacy_section_1_text(inputs)
	if (locale === "ja") return ja_privacy_section_1_text(inputs)
	return zh_privacy_section_1_text(inputs)
};